import { Tooltip } from 'antd';

function AddOnIcon(props: any) {
  const { record } = props;

  return (
    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
      {record?.expedite?.selected ? (
        <Tooltip title="Expedite">
          <img src="/expediteicon.png" alt="Expedite" style={{ width: '35px', height: '26px' }} />
        </Tooltip>
      ) : null}
      {record?.photoEnhancement?.selected ? (
        <Tooltip title="Photo Enhancement">
          <img
            src="/photoenhenceicon.png"
            alt="Photo Enhancement"
            style={{ width: '35px', height: '30px' }}
          />
        </Tooltip>
      ) : null}
      {record?.apostilled?.selected ? (
        <Tooltip title="Apostille">
          <img src="/apostileicon.png" alt="Apostille" style={{ width: '25px', height: '25px' }} />
        </Tooltip>
      ) : null}
      {record?.courierService?.selected ? (
        <Tooltip title="VFS Label Roundtrip">
          <img
            src="/vfslabelroundtripicon.png"
            alt="VFS Label Roundtrip"
            style={{ width: '26px', height: '26px' }}
          />
        </Tooltip>
      ) : null}
    </div>
  );
}

export default AddOnIcon;
